Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonType = exports.ButtonSize = void 0;
var ButtonSize = exports.ButtonSize = function (ButtonSize) {
  ButtonSize["normal"] = "normal";
  ButtonSize["small"] = "small";
  ButtonSize["large"] = "large";
  return ButtonSize;
}({});
var ButtonType = exports.ButtonType = function (ButtonType) {
  ButtonType["normal"] = "normal";
  ButtonType["brand"] = "brand";
  ButtonType["alternative"] = "alternative";
  ButtonType["outlined"] = "outlined";
  ButtonType["link"] = "link";
  ButtonType["brandLink"] = "brandLink";
  ButtonType["icon"] = "icon";
  ButtonType["iconOutlined"] = "iconOutlined";
  ButtonType["blank"] = "blank";
  return ButtonType;
}({});